<template>
  <div>
    <input ref="files" @change="update" type="file" hidden />
    <el-button class="btn" size="small" @click="openFile" v-if="uploadStatus">点击上传</el-button>
    <div class="video_box" v-if="fileInfo">
      <video :src="`${this.getaway.user}bt/file/${fileInfo}/download`" autoplay=autoplay controls=controls
             muted=muted loop=loop poster="video/mp4"></video>
    </div>

  </div>
</template>

<script>
import BigUpload from '@/js/upload'
import { videoFileType } from '@/js/fileType'

export default {
  name: 'qqVideo',
  props: {
    videoMd5: {
      type: String,
      default: ''
    },
    uploadStatus: {
      type: Boolean,
      default: true
    }
  },
  //定义v-model属性
  model: {
    prop: 'videoMd5',
    event: 'change'
  },
  watch: {
    //监听视频的修改
    videoMd5(val) {
      this.fileInfo = val
    }
  },
  data() {
    return {
      fileInfo: '',
      fileList: []
    }
  },
  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      if (this.videoMd5) {
        this.fileInfo = this.videoMd5
      }
    },

    //触发单击事件
    openFile() {
      this.$refs.files.click()
    },

    update() {
      this.uploadFile = new BigUpload({
        // url: `${this.getaway.user}bt/files/bigupload`,
        url: `${this.getaway.user}/bt/file/upload/mp4`,
        file: this.$refs.files,
        fileType: videoFileType,
        size: 2097152,
        callback: (state) => {
          if (state) {
            this.fileInfo = state
            this.$emit('getVideo', this.fileInfo.video)
            this.$emit('change', state.md5)
          }
        }
      })
      this.uploadFile.startUpload()
    },
  }
}
</script>

<style lang="less" scoped>
.video_box {
  width: 400px;
  height: 260px;

  video {
    width: 100%;
    height: 100%;
  }
}
</style>
